<template>
  <v-container fluid class="px-15 mx-15">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-form v-model="isValido">
      <v-row align="center">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title>| Relatório de Tarefas</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroUsuario"
            :items="listaDeUsuarios"
            label="Usuário"
            autocomplete="off"
            clearable
            prepend-icon="mdi-account"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.statusTarefa"
            :items="listaStatusTarefa"
            label="Status da Tarefa"
            autocomplete="off"
            clearable
            prepend-icon="mdi-progress-question"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.tipoTarefa"
            :items="listaTipoTarefa"
            label="Tipo Tarefa"
            autocomplete="off"
            clearable
            prepend-icon="mdi-shape-outline"
          >
          </v-autocomplete>
        </v-col>

        <!-- DatePicker -->
        <v-col cols="12" lg="6">
          <v-menu
            ref="menuDe"
            v-model="menuDe"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedDe"
                label="Data de Inicio"
                :rules="[required()]"
                autocomplete="off"
                prepend-icon="mdi-calendar-today"
                v-bind="attrs"
                v-mask="['##/##/####']"
                clearable
                @blur="dateDe = parseDate1(dateFormattedDe)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateDe"
              no-title
              @input="menuDe = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <!-- DatePicker ' 2 '-->
        <v-col cols="12" lg="6">
          <v-menu
            ref="menuAte"
            v-model="menuAte"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedAte"
                label="Data de Fim"
                autocomplete="off"
                prepend-icon="mdi-calendar"
                :rules="[required()]"
                v-bind="attrs"
                v-mask="['##/##/####']"
                clearable
                @blur="dateAte = parseDate2(dateFormattedAte)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateAte"
              no-title
              @input="menuAte = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" align="center">
          <v-btn
            :disabled="btnGerarRelatorio"
            width="300"
            color="#03B2EE"
            class="white--text"
            @click="gerarRelatorio"
          >
            GERAR RELATÓRIO
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <FormRelatorio
      :isTheModalOpen="formRelatorio.isOpen"
      :modalTitleToolbar="formRelatorio.modalTitleToolbar"
      :gerarExcel="true"
      :gerarPdf="true"
      v-on:formrelatorio-close="formRelatorioClose"
      v-on:formrelatorio-excel="saveExcel(formRelatorio.dataRelatorio.infoTabela)"
      v-on:formrelatorio-pdf="savePdf(formRelatorio.dataRelatorio.infoTabela)"
    >
        <v-row>
            <v-col cols="12">
                <v-card class="mx-5">
                    <v-card-title>• Informações de Tarefas</v-card-title>
                    <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataInicio" class="pl-10 pt-3">
                        <b>• de {{formRelatorio.dataRelatorio.dataInicio}} até {{formRelatorio.dataRelatorio.dataFim}}</b>
                    </v-card-subtitle>

                    <DataTable
                        :tableTitle="'Tarefas'"
                        :tableHeader="header"
                        :tableRows="formRelatorio.dataRelatorio.infoTabela"
                    ></DataTable>
                </v-card>
            </v-col>
        </v-row>
    </FormRelatorio>
  </v-container>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import FormRelatorio from "../components/FormRelatorio";
import DataTable from "@/components/DataTable2.vue";
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver';
import Blob from 'blob'
import Alertas from "../components/Alertas.vue";
import validation from "@/utils/validation.js"

export default {
  components: {
    FormRelatorio,
    DataTable,
    Alertas,
  },

  data: () => ({
    ...validation,
    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    btnGerarRelatorio: false,
    isValido: true,

    //DatePicker
    dateDe: null,
    dateAte: null,
    dateFormattedDe: null,
    dateFormattedAte: null,
    menuDe: false,
    menuAte: false,

    //formRelatorio
    formRelatorio: {
      isOpen: false,
      modalTitleToolbar: "Relatório Gerado",
      actionSearch: {
        numeroUsuario: null,
        statusTarefa: null,
        tipoTarefa: null,
        dataInicio: null,
        dataFim: null,
        tipoRequisicao: 'relatorio'
      },
      dataRelatorio: {
        dataInicio: null,
        dataFim: null,
        infoTabela: [],
      },
    },

    //#region HEADERS
    header: [
      {
        text: "ID",
        value: "tarefa.numeroTarefa",
      },
      {
        text: "Nome Fiscal",
        value: "usuario.nomeUsuario",
      },
      {
        text: "Nome Fantasia",
        value: "empresa.nomeFantasia",
      },
      {
        text: "Credencial",
        value: "usuario.numeroRegistro",
      },
      {
        text: "Razão Social",
        value: "empresa.razaoSocial",
      },
      {
        text: "Endereço",
        value: "endereco.endereco",
      },
      {
        text: "CEVS",
        value: "endereco.cevs",
      },
      {
        text: "Roteiro",
        value: "roteiro.nomeRoteiro",
      },
      {
        text: "Data Registro",
        value: "tarefa.dataCriacaoTarefa",
      },
      {
        text: "Status Tarefa",
        value: "tarefa.statusTarefa",
      },
      {
        text: "Tipo Tarefa",
        value: "tarefa.tipoTarefa",
      },
    ],
    //#endregion

    listaDeUsuarios: [],
    listaStatusTarefa: [
        {
          text: "Em Andamento",
          value: 0
        },
        {
          text: "Concluída",
          value: 1
        },
        {
          text: "Adiado",
          value: 2
        },
        {
          text: "Processo Aberto",
          value: 4
        },
        {
          text: "Concluída",
          value: 3
        },
        {
          text: "Concluída com Atraso",
          value: 5
        }
    ],
    listaTipoTarefa: [
        {
            text: "Tarefa",
            value: 0
        },
        {
            text: "Denúncia",
            value: 1
        },
        {
            text: "Retorno",
            value: 2
        }
    ],
    selectedItem: null,

    rules: {
      required: (value) => value.length > 0 || "Requer o campo!",
    },
  }),

  created() {
    this.initialize();
  },

  computed: {
    computedDateFormatted1() {
      return this.formatDate1(this.dateDe);
    },
    computedDateFormatted2() {
      return this.formatDate2(this.dateAte);
    },
  },

  watch: {
    dateDe() {
      this.dateFormattedDe = this.formatDate1(this.dateDe);
      this.formRelatorio.actionSearch.dataInicio = this.dateDe
    },
    dateAte() {
      this.dateFormattedAte = this.formatDate2(this.dateAte);
      this.formRelatorio.actionSearch.dataFim = this.dateAte
    },
    isValido() {
      this.btnGerarRelatorio = !this.isValido;
    },
  },

  methods: {
    async initialize() {
      try {
        const response = await axios.put('usuariosNivel', {numeroNivel: 16}, this.config)
        this.listaDeUsuarios = response.data.map((usuarioSelecionado) => {
          return {
            value: usuarioSelecionado.numeroUsuario,
            text: usuarioSelecionado.nomeUsuario
          }
        })
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      }
    },

    async gerarRelatorio() {
      try {
        const responseRelatorio = await axios.put("relatorio", this.formRelatorio.actionSearch, this.config)
        
        this.formRelatorio.dataRelatorio.infoTabela = responseRelatorio.data;

        if(this.formRelatorio.actionSearch.dataInicio) {
            this.formRelatorio.dataRelatorio.dataInicio = this.dateFormattedDe
            if(this.formRelatorio.actionSearch.dataFim) {
                this.formRelatorio.dataRelatorio.dataFim = this.dateFormattedAte
            } else {
                this.formRelatorio.dataRelatorio.dataFim = this._formatStringInBrazilianDateFormat(new Date().toISOString().substr(0, 10))
            }
        }
        
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.formRelatorio.isOpen = true;
      }
    },

    formRelatorioClose() {
      this.formRelatorio.isOpen = false;

      this.formRelatorio.actionSearch.numeroUsuario = null;
      this.formRelatorio.actionSearch.statusTarefa = null;
      this.formRelatorio.actionSearch.tipoTarefa = null;
      this.formRelatorio.actionSearch.dataInicio = null;
      this.formRelatorio.actionSearch.dataFim = null;

      this.formRelatorio.dataRelatorio.infoTabela = [];
      this.formRelatorio.dataRelatorio.dataInicio = null;
      this.formRelatorio.dataRelatorio.dataFim = null;

      this.dateFormattedDe = null;
      this.dateFormattedAte = null;
      this.dateDe = null;
      this.dateAte = null;
    },

    //#region FORMATERS
    formatDate1(dateDe) {
      if (!dateDe) return null;

      const [day, month, year] = dateDe.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate1(dateDe) {
      if (!dateDe) return null;
      const [day, month, year] = dateDe.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return 'Sem Data';
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    formatarIcStatusTarefa(item) {
      if(item == 0) {
        return "Em andamento"
      } else if(item == 1) {
        return "Concluida"
      }
    },

    formatarTipoTarefa(item) {
      if(item == 0) {
        return "Tarefa"
      } else if(item == 1) {
        return "Denúncia"
      } else if(item == 2) {
        return "Retorno"
      }
    },
    //#endregion

    saveExcel(conteudo) {
      try {
        const workbook = new Workbook()
        var worksheet = workbook.addWorksheet('Relatorio Tarefas', { properties: {tabColor:{argb:'FF00FF00'}}, views:[ { showGridLines:false } ] })

        worksheet.columns = [
          {key: 'col1', width: 10},
          {key: 'col2', width: 30},
          {key: 'col3', width: 30},
          {key: 'col4', width: 30},
          {key: 'col5', width: 30},
          {key: 'col6', width: 30},
          {key: 'col7', width: 30},
          {key: 'col8', width: 40},
          {key: 'col9', width: 20},
          {key: 'col10', width: 25},
          {key: 'col11', width: 20}
        ];

        const headerTable = worksheet.addRow({
          col1: 'ID',
          col2: 'Nome Fiscal',
          col3: 'Nome Fantasia',
          col4: 'Credencial',
          col5: 'Razão Social',
          col6: 'Endereço',
          col7: 'CEVS',
          col8: 'Roteiro',
          col9: 'Data Registro',
          col10: 'Status Tarefa',
          col11: 'Tipo Tarefa',
        })
        headerTable.font = { name: 'Calibri', size: 12, bold: true, color: {argb: '262626'} }
        headerTable.alignment = { vertical: 'top', horizontal: 'center' };

        conteudo.map(tarefaSelecionada => {
          worksheet.addRow({
            col1: tarefaSelecionada.tarefa.numeroTarefa,
            col2: tarefaSelecionada.usuario.nomeUsuario,
            col3: tarefaSelecionada.empresa.nomeFantasia,
            col4: tarefaSelecionada.usuario.numeroRegistro,
            col5: tarefaSelecionada.empresa.razaoSocial,
            col6: tarefaSelecionada.endereco.endereco,
            col7: tarefaSelecionada.endereco.cevs,
            col8: tarefaSelecionada.roteiro.nomeRoteiro,
            col9: this._formatStringInBrazilianDateFormat(tarefaSelecionada.tarefa.dataCriacaoTarefa),
            col10: this.formatarIcStatusTarefa(tarefaSelecionada.tarefa.statusTarefa),
            col11: this.formatarTipoTarefa(tarefaSelecionada.tarefa.tipoTarefa),
          }).alignment = { vertical: 'top', horizontal: 'left' };


          var borderStyles = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
      
          worksheet.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });
        })

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          saveAs(blob, "relatorio.xlsx");
        });

        this.rowPosition = 0
      } catch (error) {
        console.log(error)
      }
    },

    savePdf(conteudo) {
      console.log(conteudo)
    },
  },
};
</script>
